export default "__VITE_ASSET__8f89df92__"